<template>
  <div style="background-color: #f4fbff">
    <Header
      :leftArrow="true"
      :leftText="''"
      @leftClick="onClickLeft"
      :rightIcons="false"
    >
    </Header>
    <div class="login" v-show="isInfoBack">
      <div class="login-wrap">
        <div class="login_id-pass">
          <div class="login_input-box two-fac">
            <p class="login_two-fac_title">２段階認証</p>
            <p class="login_two-fac_ex">
              下記の方法より、２段階認証ができます。<br />この設定は後から変更可能です。
            </p>
            <van-form ref="form">
              <van-switch
                v-model="authInfo"
                active-color="#3B82C4"
                class="radio-bottom"
                @change="changeAuthInfo"
              />
              <div v-show="this.authInfo">
                <van-radio-group v-model="authType">
                  <van-radio
                    name="email"
                    icon-size="30px"
                    checked-color="#3B82C4"
                    class="radio-bottom"
                    >Eメール</van-radio
                  >
                  <!-- <van-radio
                name="line"
                icon-size="30px"
                checked-color="#6AA43B"
                class="radio-bottom"
                >電話番号（通話）</van-radio
              > -->
                  <van-radio
                    name="sms"
                    icon-size="30px"
                    checked-color="#3B82C4"
                    class="radio-bottom"
                    >電話番号（SMS）</van-radio
                  >
                </van-radio-group>
                <div v-if="this.authType == 'email'">
                  <p id="login_two-fac_input-name">Eメール</p>
                  <input
                    type="email"
                    id="two-fac_input"
                    name="name"
                    required=""
                    placeholder="oooooooo@ooo.oo"
                    v-model="userInfo.mail"
                  />
                  <p v-if="emailError" style="color: red; margin-top: 6px">
                    メールアドレスの入力形式が正しくありません。
                  </p>
                </div>
                <div v-else>
                  <p id="login_two-fac_input-name">電話番号</p>
                  <input
                    type="tel"
                    id="two-fac_input"
                    name="name"
                    required=""
                    placeholder="000-0000-0000"
                    v-model="userInfo.tel"
                  />
                  <p style="color: red; margin-top: 6px">
                    ※ハイフンなし、数字のみ入力
                  </p>
                  <p v-if="telError" style="color: red; margin-top: 6px">
                    電話番号の入力形式が正しくありません。
                  </p>
                </div>
              </div>
            </van-form>
          </div>
          <van-button
            style="margin-top: 30px"
            :disabled="
              !this.userInfo.mail && !this.userInfo.tel && this.authInfo == true
            "
            block
            :color="
              !this.userInfo.mail && !this.userInfo.tel && this.authInfo == true
                ? '#AACBE7'
                : '#3B82C4'
            "
            type="primary"
            native-type="submit"
            :loading="loading"
            @click="handleSure"
            id="authentication_btn"
          >
            設定する
          </van-button>
        </div>
      </div>
    </div>
    <div class="mypage mypage_change mypage_change-pass" v-show="!isInfoBack">
      <div class="wrap mypage_wrap">
        <div class="login_id-pass">
          <div class="login_input-box two-fac new-pass">
            <p class="login_two-fac_title">
              認証のため、<br />現在のパスワードを入力してください。
            </p>
            <van-form style="width: 100%; max-width: 500px" ref="formPwd">
              <p class="login_cont-name">現在のパスワード</p>
              <div class="login_pass-box">
                <input
                  class="password"
                  name="password"
                  required
                  v-model="formData.password"
                  :type="pwdFlag ? 'password' : 'text'"
                />
                <button class="btn_passview">
                  <img
                    src="@/assets/img/login/pass.png"
                    :class="[this.pwdFlag ? '' : 'img-opacity']"
                    @click="changePwd"
                    alt="非表示"
                  />
                </button>
              </div>
            </van-form>
          </div>
          <van-button
            :disabled="!this.formData.password"
            block
            :color="!this.formData.password ? '#AACBE7' : '#3B82C4'"
            type="primary"
            native-type="submit"
            @click="verifyPwd"
            id="pwd_verify"
            >次へ</van-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import { GetUserDetails, UpdateUser, VerifyUserPwd } from "@/services/user";
import { Toast } from "vant";
import "vant/es/toast/style";

export default {
  data() {
    return {
      user: JSON.parse(localStorage.getItem(process.env.VUE_APP_USER_KEY)),
      numbers: "",
      authInfo: false,
      authType: "email",
      userInfo: {},
      isInfoBack: false,
      loading: false,
      formData: {},
      pwdFlag: true,
      mail: "",
      tel: "",
      emailError: false,
      telError: false,
    };
  },
  components: {
    Header,
  },
  created() {},
  mounted() {},
  methods: {
    verifyPwd() {
      this.$refs.formPwd
        .validate()
        .then(() => {
          const detail = this.formData;
          VerifyUserPwd(detail).then((res) => {
            if (res.data.code >= 0) {
              this.initUserInfo();
            } else {
              let error_msg = "パスワードが正しくありません。";
              Toast.fail(error_msg);
            }
          });
        })
        .catch(() => {});
    },
    changePwd() {
      this.pwdFlag = !this.pwdFlag;
    },
    initUserInfo() {
      GetUserDetails().then((res) => {
        this.userInfo = res.data.data.detail;
        this.setAuth(this.userInfo.auth_type);
        if (this.userInfo) {
          this.mail = this.userInfo.mail;
          this.tel = this.userInfo.tel;
        }
        this.isInfoBack = true;
        this.$forceUpdate();
      });
    },
    onClickLeft() {
      history.back();
    },
    handleSure() {
      this.loading = true;
      if (this.authInfo) {
        if (this.authType == "email" && !this.userInfo.mail) {
          Toast.fail("メールアドレスを入力してください。");
          this.loading = false;
          return;
        }
        if (this.authType == "sms" && !this.userInfo.tel) {
          Toast.fail("電話番号を入力してください。");
          this.loading = false;
          return;
        }
        if (this.authType == "email") {
          if (
            !this.userInfo.mail.match(/[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/i)
          ) {
            this.emailError = true;
            this.loading = false;
            return;
          } else {
            this.emailError = false;
          }
        } else {
          if (!this.userInfo.tel.match(/^0[6-9]0\d{8}$/)) {
            this.telError = true;
            this.loading = false;
            return;
          } else {
            this.telError = false;
          }
        }
      }
      this.getAuth();

      this.$refs.form
        .validate()
        .then(() => {
          const detail = {
            id: this.userInfo.id,
            auth_type: this.userInfo.auth_type,
          };
          if (this.userInfo.mail != this.mail) {
            detail.mail = this.userInfo.mail;
          }
          if (this.userInfo.tel != this.tel) {
            detail.tel = this.userInfo.tel;
          }
          UpdateUser(detail).then((res) => {
            if (res.data.code >= 0) {
              Toast.success("設定が変更されました。");
              setTimeout(() => {
                this.$router.push("/user");
              }, 1500);
            } else {
              Toast.fail("設定が変更できませんでした。");
              this.loading = false;
            }
          });
        })
        .catch(() => {});
    },
    setAuth(status) {
      if (status === "email" || status === "sms" || status === "line") {
        this.authInfo = true;
        this.authType = status;
      } else {
        this.authInfo = false;
      }
    },
    getAuth() {
      if (!this.authInfo) {
        this.authType = "none";
      }
      this.userInfo.auth_type = this.authType;
    },
    changeAuthInfo(checkStatus) {
      this.authInfo = checkStatus;
    },
  },
  computed: {},
  watch: {},
};
</script>

<style scoped>
   
   
  
   
#authentication_btn {
  width: 100%;
  height: 54px;
  background: #aacbe7;
  border-radius: 8px;
  color: #fff;
  display: block;
  font-size: 20px;
  line-height: 54px;
  text-align: center;
  margin-top: auto;
}
#two-fac_input:focus {
  border: 2px solid #e59700;
}
.radio-bottom {
  margin-bottom: 29px;
}
.van-radio__label {
  font-weight: 700;
  font-size: 18px;
  margin-left: 18px;
}
.van-radio__icon--round .van-icon {
  border: 3px solid #747678;
}
@media screen and (min-width: 481px) {
  .login-wrap {
    width: 400px;
  }
}
@media screen and (min-width: 1023px) {
}
::placeholder {
  color: #dfe1e4;
}

#pwd_verify {
  width: 100%;
  height: 54px;
  background: #aacbe7;
  border-radius: 8px;
  color: #fff;
  display: block;
  font-size: 20px;
  line-height: 54px;
  text-align: center;
  margin-top: 40px;
  border: 1px solid;
}
#pwd_verify.possible {
  background: #3b82c4;
  pointer-events: auto;
}
</style>
